import { normalizeUri, get } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toItem(data) {
  return {
    id: data.id,
    name: data.title || '',
    source: 'unsplash',
    kind: ItemKind.File,
    folderId: null,
    mediaType: MediaType.Picture,
    fileUrl: normalizeUri(get(data, 'urls.full')),
    // small is 400px, thumb is 200px, regular 1080
    thumbnailUrl: normalizeUri(get(data, 'urls.small')),
    previewUrl: normalizeUri(get(data, 'urls.regular')),
    createdAt: null,
    tags: data.tags,
    width: data.width,
    height: data.height,
    creator: get(data, 'photographer.name'),
    creatorPicture: get(data, 'photographer.profileImage'),
    creatorUrl: get(data, 'photographer.portfolioUrl')
  };
}